import { DetailedHTMLProps } from "react";
import "./TextArea.scss";
export function TextArea(props:DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement> ,HTMLTextAreaElement>) {
    return (
        <textarea className="TextArea" {...props} />
       
    );
}